import CustomCard from '../../../../components/CustomCard';
import { CompletePersonChip, IconHandCard, OutlinedCalendarIcon } from '../../../../components/buttons/IconButtons';
import { Trans } from 'react-i18next';
import {useSelector} from "react-redux";
import NotInformation from "../../../../components/NotInformation";
import React from "react";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const ReservationPolicies = ({ t }) => {
    const { getEventSetting } = useSelector((state) => state?.EmployeeEventsSlice);

    return (
        <>
            <CustomCard classCard='card-border-8px p-0' classContent='p-0 overflow-hidden'>
                <div className='d-flex align-items-center p-3'>
                    <div><IconHandCard /></div>
                    <div className='ml-2'>
                        <p className={'font-color-general-950 ibl-font-w-600 fs-14px'}>{t('policies')}</p>
                    </div>
                </div>
                <div className='border-bottom-shades-300' />
                { !getEventSetting?.bookingWindowEnabled && !getEventSetting?.attendeesLimitsEnabled ?
                    <div className='h-170px'>
                        <NotInformation text={t('no_policies_found')} card={true} className={"h-100"}
                                        classNameImage={"h-100px py-1"}/>
                    </div>
                    :
                    <div className='h-170px d-flex align-items-center p-3'>
                        <div>
                            { getEventSetting?.bookingWindowEnabled &&
                            <div className={' d-flex align-items-center'}>
                                <OutlinedCalendarIcon className='btn-icon-svg-24px' />
                                <p className='pl-2'>
                                    <Trans
                                        i18nKey='booking_opens_value_days_in_advance'
                                        values={{ days: getEventSetting?.advanceBookingLimit }}
                                        components={{ strong: <span className='fs-14px ibl-font-w-700 font-color-general-950' /> }}
                                    />
                                </p>
                            </div>
                            }
                            { getEventSetting?.attendeesLimitsEnabled &&
                            <div className={` d-flex align-items-center ${getEventSetting?.bookingWindowEnabled ? "mt-3": ""}`}>
                                <CompletePersonChip className='btn-icon-svg-24px'/>
                                <p className='pl-2'>
                                    <Trans
                                        i18nKey='maximum_value_attendees_per_reservation'
                                        values={{ value: getEventSetting?.attendeesLimitsValue }}
                                        components={{ strong: <span className='fs-14px ibl-font-w-700 font-color-general-950' /> }}
                                    />
                                </p>
                            </div>
                            }
                        </div>
                    </div>
                }
            </CustomCard>
        </>
    );
};

export default ReservationPolicies;
